import React, { useEffect, useRef, useState } from 'react'
import './StockAnalysisCompare.scss'
import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHexagonCheck } from '@fortawesome/pro-solid-svg-icons'
import { faHexagon } from '@fortawesome/pro-light-svg-icons'
import Dropdown from 'react-bootstrap/Dropdown';
import lodash, { set } from 'lodash';
import { CompareServiceApi } from "../../../services/stockAnalysis/api";
import { Configuration } from "../../../services/stockAnalysis/configuration"
import { SectorServiceApi } from "../../../services/actionHub";
import * as actionHubConfig from "../../../services/actionHub/configuration";
import { useSelector } from "react-redux";
import NumberFormatter from '../../../formatters/NumberFormatter';
import Spinner from '../../../components/spinner';
import DataTableComponent from '../../../components/dataTables/dataTable';
import { Toast } from 'primereact/toast';
import { APIControl } from '../../../helpers/APIControl'
import { useTranslation } from "react-i18next";
export default function StockAnalysisCompare() {
    const { t, i18n } = useTranslation();
    // Sektör/şirket adları servisten { trTR, enUS } olarak geliyor; dile göre seç, yoksa TR'ye düş.
    const localizedName = (value) => (i18n.language === 'en-US' ? (value?.enUS || value?.trTR) : value?.trTR) || '';
    const toast = useRef(null);
    const numberFormatter = new NumberFormatter();
    const api = new CompareServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const actionHubApi = new SectorServiceApi(new actionHubConfig.Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const user = useSelector((state) => state.auth?.user);
    const token = useSelector((state) => state.auth?.token);
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedSectorList, setSelectedSectorList] = useState([]);
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [sectorList, setSectorList] = useState([]);
    const [compareDataTable, setCompareDataTable] = useState([])
    const [compareDataColumns, setCompareDataColumns] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [openFirst, setOpenFirst] = useState(false);
    const [openSecond, setOpenSecond] = useState(false);
    const firstDropdownRef = useRef(null);
    const secondDropdownRef = useRef(null);

    const columnsAll = [
        { id: 2, field: 'searchableHeader', displayName: 'code', header: '', filterField: "code", isFrozen: true, format: "code-s-f", isVisible: true, align: 'left', width: '1%', paddingRight: '0px', sortable: false },
        // { id: 0, field: 'fav', displayName: 'Favoriler', header: '', isVisible: true, align: 'left' },
        // { id: 1, field: 'code', diGsplayName: 'Hisse Kodu', header: 'Hisse Kodu', isVisible: true, align: 'left', width: '14%', clikable: true, sortable: true },
        { id: 2, field: 'FK', displayName: 'F/K', header: t('tableHeader.p-e'), isVisible: true, align: 'right', width: '15%', sortable: true },
        { id: 3, field: 'PD', displayName: 'PD/DD', header: t('tableHeader.pp-dd'), isVisible: true, align: 'right', width: '15%', sortable: true },
        { id: 4, field: 'FSell', displayName: 'F/Satışlar', header: t('tableHeader.p-Sales'), isVisible: true, align: 'right', width: '15%', sortable: true },
        { id: 5, field: 'dividendGrowth', displayName: 'Temettü Büyümesi', header: t('tableHeader.dividendGrowth'), isVisible: true, align: 'right', width: '15%', sortable: true },
        { id: 6, field: 'profitIncrease', displayName: 'Kar Artışı', header: t('tableHeader.profitIncrease'), template: '', isVisible: true, align: 'right', width: '15%', sortable: true },
        { id: 7, field: 'fvaok', displayName: 'FVAÖK Marji', header: t('tableHeader.ebidataMargin'), isVisible: true, align: 'right', width: '10%', sortable: true },
    ];

    useEffect(() => {

        if (selectedSecurity.id && sectorList.length > 0) {

            let objectId = selectedSecurity.id;

            let findIndex = lodash.findIndex(sectorList, (it) => { // seçilmiş hissenin sektörünü buluyoruz.
                return it.companies.find((it) => {
                    return it.entityId === objectId
                })
            })
            if (findIndex !== -1) {
                setSelectedSectorList([sectorList[findIndex]]);
            } else {
                setSelectedSectorList([sectorList[0]]);
            }
        }

    }, [selectedSecurity, sectorList])


    useEffect(() => {
        getSectors();
    }, []);


    useState(() => {
        setCompareDataColumns(columnsAll);
    }, []);

    //#region sector dropdown
    useEffect(() => {
        if (selectedSectorList.length === 0) return;
        let companyList = [];
        selectedSectorList.forEach((item) => {
            companyList = [...companyList, ...item.companies.map((item) => { return { code: item.code, name: localizedName(item.companyName), entityId: item.entityId } })]
        });
        setCompanyList(companyList);
    }, [selectedSectorList]);

    useEffect(() => {
        if (companyList.length === 0) return;
        setSelectedCompanyList(companyList);
    }, [companyList]);

    useEffect(() => {
        if (selectedCompanyList.length === 0) return;
        getCompareData();
    }, [selectedCompanyList])

    const changeSectorValue = (item) => {
        let index = lodash.findIndex(selectedSectorList, (it) => {
            return it.sectorId === item.sectorId
        })

        if (index === -1) {

            setSelectedSectorList([...selectedSectorList, item]);
        }
        else {
            setSelectedSectorList(selectedSectorList.filter((it) => it.sectorId !== item.sectorId))
        }

        // getCompanyListData();

    }

    const selectAllSector = () => {

        if (!selectAll) {
            const testAll = sectorList.filter((it) => { return it.id !== 10 && it.id !== 1 })
            setSelectedSectorList(testAll)
            setSelectAll(true)
        }
        else {
            setSelectAll(false)
            setSelectedSectorList([])
        }

        //getCompanyListData();

    }

    const checkSectorControl = (item) => {
        let index = lodash.findIndex(selectedSectorList, (it) => {
            return it.sectorId === item.sectorId
        })
        if (index === -1) return false;
        else return true
    }
    //#endregion


    //#region company dropdown


    const changeCompanyValue = (item) => {

        let index = lodash.findIndex(selectedCompanyList, (it) => {
            return it.code === item.code
        })

        if (index === -1) {

            setSelectedCompanyList([...selectedCompanyList, item]);
        }
        else {
            setSelectedCompanyList(selectedCompanyList.filter((it) => it.code !== item.code))
        }

    }

    const checkCompanyControl = (item) => {
        let index = lodash.findIndex(selectedCompanyList, (it) => {
            return it.code === item.code
        })
        if (index === -1) return false;
        else return true
    }


    //#endregion

    //ticker a göre tablonun dataları burada setlenicek.


    //#region  API CALLS

    const getSectors = () => {
        actionHubApi.actionhubSectorGet(token).then((res) => {
            // console.log(res);
            if (res.data.error !== "") return;
            setSectorList(res.data.sectorSnap);
        }).catch((err) => {
            // console.log(err);
        })
    }

    const getCompareData = () => {
        setIsLoading(true);
        let culture = "tr-TR"
        let entityIds = selectedCompanyList.map((item) => item.entityId);

        if (entityIds.length === 0) {
            setIsLoading(false);
            return;
        }

        // Maksimum entity ID sayısını belirleyin
        const MAX_IDS_PER_REQUEST = 100;
        let promises = [];
        let _data = [];

        // Entity IDs'yi belirlediğiniz maksimum sayıya göre parçalara ayırın
        for (let i = 0; i < entityIds.length; i += MAX_IDS_PER_REQUEST) {
            let idsSlice = entityIds.slice(i, i + MAX_IDS_PER_REQUEST);

            // Her bir parça için ayrı bir API isteği yapın
            promises.push(
                api.compareCompareGet(token, culture, idsSlice)
                    .then(res => {
                        if (res.data.error !== "") {
                            toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                            return [];
                        }
                        return res.data.rows.map((item, index) => ({
                            id: i + index,
                            code: item.code,
                            uniqueCode: item.uniqueCode,
                            name: item.name,
                            FK: numberFormatter.Double(item.fk, 2),
                            PD: numberFormatter.Double(item.pddd, 2),
                            FSell: numberFormatter.Double(item.sales, 2),
                            dividendGrowth: numberFormatter.Double(item.dividend, 2),
                            profitIncrease: numberFormatter.Double(item.pgrowth, 2),
                            fvaok: numberFormatter.Double(item.ebitda, 2),
                            isFav: false,
                            entityId: item.entityId
                        }));
                    })
                    .catch(err => {
                        console.error('API error:', err);
                        return [];
                    })
            );
        }

        // Tüm istekler tamamlandığında verileri birleştirin ve state'i güncelleyin
        Promise.all(promises).then(results => {
            results.forEach(result => {
                _data = _data.concat(result);
            });
            setCompareDataTable(_data);
            setIsLoading(false);
        });
    }

    //#endregion API CALLS

    useOutsideClick(firstDropdownRef, () => setOpenFirst(false));
    useOutsideClick(secondDropdownRef, () => setOpenSecond(false));

    return (
        <div id='stockAnalysisCompare'>
            <Toast ref={toast} position="bottom-right" />

            <Container className='p-0 m-t-15'>
                <Row className='m-b-15'>
                    <Col md="3" sm="3" xl="3" xs="3" ref={firstDropdownRef}>
                        <Dropdown show={openFirst} onToggle={() => setOpenFirst(!openFirst)} data-bs-theme="dark" className='multiple-dropdown' autoClose={false}>
                            <Dropdown.Toggle variant="secondary">
                                {selectedSectorList.length !== 0 ?
                                    (
                                        selectedSectorList.length > 1 ? selectedSectorList.length + ' ' + t('compare.sectorsSelected') : localizedName(selectedSectorList[0].sectorName)
                                    ) :
                                    (t('compare.selectSector'))}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={(e) => selectAllSector()} className={selectAll ? 'comboActiveItem' : ''}>{t('compare.allExceptBankInsurance')}
                                    {selectAll ? (
                                        <FontAwesomeIcon icon={faHexagonCheck} />
                                    ) : (
                                        <FontAwesomeIcon icon={faHexagon} />
                                    )}
                                </Dropdown.Item>
                                {sectorList.map((item, index) => (
                                    <Dropdown.Item onClick={(e) => changeSectorValue(item)} className={checkSectorControl(item) ? 'comboActiveItem' : ''} key={item.sectorId}>
                                        <span>{localizedName(item.sectorName)}</span>
                                        {checkSectorControl(item) ? (
                                            <FontAwesomeIcon icon={faHexagonCheck} />
                                        ) : (
                                            <FontAwesomeIcon icon={faHexagon} />
                                        )}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    <Col md="3" sm="3" xl="3" xs="3" ref={secondDropdownRef}>
                        <Dropdown show={openSecond} onToggle={() => setOpenSecond(!openSecond)} data-bs-theme="dark" className='multiple-dropdown' autoClose={false}>
                            <Dropdown.Toggle variant="secondary">
                                {selectedCompanyList.length !== 0 ?
                                    (
                                        selectedCompanyList.length > 1 ? selectedCompanyList.length + ' ' + t('compare.companiesSelected') : selectedCompanyList[0].name
                                    ) :
                                    (t('compare.selectCompany'))}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {companyList.map((item, index) => (
                                    <Dropdown.Item onClick={(e) => changeCompanyValue(item)} className={checkCompanyControl(item) ? 'comboActiveItem' : ''} key={item.code}>

                                        <span>{item.name}</span>
                                        {checkCompanyControl(item) ? (
                                            <FontAwesomeIcon icon={faHexagonCheck} />
                                        ) : (
                                            <FontAwesomeIcon icon={faHexagon} />
                                        )}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>

                </Row>

                <Row>
                    <Col className='stock-compare-table'>
                        {isLoading && <Spinner height="600px" />}
                        {!isLoading &&
                            <DataTableComponent columnsProp={compareDataColumns} dataProp={compareDataTable} columnsSelect={false} search={false} absoluteSearch={false} scrollHeight={'100%'} />
                        }
                    </Col>
                </Row>


            </Container>
        </div>
    )
}
function useOutsideClick(ref, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
}